import { DropdownDataTransformationsFnsEnum } from "@ryde/shared";

import { DropdownCustomTransformationsMapType } from "../models";
import {
  useBookingStationOptionCustomTransformerFn,
  usePassengerSourceStation2OfficialFilterTransformerFn,
} from "../transformers";

interface IUseDropdownsCustomTransformationMap {
  dropdownsTransformationsMap: DropdownCustomTransformationsMapType;
}

export const useDropdownsTransformationMap =
  (): IUseDropdownsCustomTransformationMap => {
    const { bookingStationOptionCustomTransformerFn } =
      useBookingStationOptionCustomTransformerFn();
    const { passengerSourceStation2OfficialFilterTransformerFn } =
      usePassengerSourceStation2OfficialFilterTransformerFn();

    const dropdownsTransformationsMap: DropdownCustomTransformationsMapType = {
      [DropdownDataTransformationsFnsEnum.BOOKINGS_STATIONS_OPTIONS]:
        bookingStationOptionCustomTransformerFn,
      [DropdownDataTransformationsFnsEnum.PASSENGER_SOURCE_STATION2_OFFICIAL_FILTER]:
        passengerSourceStation2OfficialFilterTransformerFn,
    } as const;

    return { dropdownsTransformationsMap };
  };
